import type { TripPlannerSurfaceActivityEntry } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityEntryTypes'
import { boundActivityDisplayText } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityDisplayText'

interface FlightSearchSubmittedParams {
  originAirportCode: string
  destinationAirportCode: string
  departureDate: string
  returnDate?: string
}

export function buildFlightSearchSubmittedActivityEntry({
  originAirportCode,
  destinationAirportCode,
  departureDate,
  returnDate,
}: FlightSearchSubmittedParams): TripPlannerSurfaceActivityEntry {
  const returnSuffix = returnDate ? `, returning ${returnDate}` : ''

  return {
    kind: 'flight_search_submitted',
    label: 'Searched flights',
    displayText: boundActivityDisplayText(
      `Searched flights from ${originAirportCode} to ${destinationAirportCode}, departing ${departureDate}${returnSuffix}`,
    ),
    sourcePath: 'trip_planner.search.flight',
    dataClassification: 'personalised_surface',
    occurredAt: new Date().toISOString(),
  }
}
